import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileSignature, faPercent, faUsers } from "@fortawesome/free-solid-svg-icons";

import { RouteInfoType } from "../../types/types";

import ClientsLayout from "./ClientsLayout";
import ClientsListPage from "./pages/client/ClientsListPage";
import ClientOrdersPage from "./pages/orders/ClientOrdersPage";
import CouponsListPage from "../coupons/pages/CouponsPage";
import { IconProp } from "@fortawesome/fontawesome-svg-core";



const clientsRoutes = [{
    id: "clients",
    name: "CRM",
    path: "/clients",
    icon: <FontAwesomeIcon icon={faFileSignature as IconProp} size={"lg"}/>,
    component: ClientsLayout,
    header: "CRM",
    nonCollapsable: true,
    routes: [
        {
            path: "/clients/list",
            name: "clients",
            component: ClientsListPage,
            icon: <FontAwesomeIcon icon={faUsers as IconProp} size={"lg"}/>,
        },
        {
            path: "/clients/orders/:clientId",
            name: "ordersList",
            component: ClientOrdersPage,
            hide: true
        },
        {
            path: "/clients/coupons/list",
            name: "coupons",
            component: CouponsListPage,
            icon: <FontAwesomeIcon icon={faPercent as IconProp} size={"lg"}/>,
        },
    ]
}];

export default clientsRoutes as RouteInfoType[];
